<template>
  <div v-if="!loader">
    <v-btn
      @click="createDialog = true"
      x-large
      class="ma-6 pa-2 rounded-xl"
      color="primary"
    >
      {{ $t("add educational level") }}<v-icon class="ma-2">mdi-plus</v-icon>
    </v-btn>
    <create
      @createData="create"
      @closePopup="createDialog = false"
      :dialog="createDialog"
      :loader="craeteLoader"
    />
    <edit
      @editData="edit"
      @closePopup="editDialog = false"
      :dialog="editDialog"
      :orginalData="editData"
      :loader="editLoader"
    />
    <delete-popup
      @deleteData="deleteItem($event)"
      @closePopup="deleteDialog = false"
      :dialog="deleteDialog"
      :loader="deleteLoader"
      :item="deleteData"
    />

    <v-row>
      <v-col
        lg="6"
        md="6"
        cols="12"
        v-for="(item, index) in items"
        :key="index"
      >
        <card
          @clicked="$emit('clicked', $event)"
          :icon="'mdi-order-alphabetical-ascending'"
          :item="item"
          :editAble="editAble"
          :deleteAble="deleteAble"
        />
      </v-col>
    </v-row>
  </div>
  <pulse-loader
    v-else
    :loading="true"
    :color="$vuetify.theme.themes.light.primary"
    size="20px"
  />
</template>
<script>
import { Educational } from "@/store/common/educational_level";
import card from "../card.vue";
import create from "@/pages/Dashboard/schools/semesters & managers/semesters/create.vue";
import edit from "@/pages/Dashboard/schools/semesters & managers/semesters/edit.vue";
export default {
  props: ["id", "enableEdit"],
  components: {
    create,
    edit,
    card,
  },
  data() {
    return {
      Educational,
      createDialog: false,
      editDialog: false,
      editData: null,
      deleteDialog: false,
      deleteData: null,
    };
  },
  methods: {
    //create
    async create(data) {
      let payload = {
        name: data.name,
        semester_id: this.id,
      };
      await this.name.post(payload);
      this.createDialog = false;
      this.name.get({ semester_id: this.id });
    },

    //edit
    editAble(data) {
      this.editData = data;
      this.editDialog = true;
    },
    async edit(data) {
      await this.name.edit(data.data, data.id);
      this.editDialog = false;
      this.name.get({ semester_id: this.id });
    },

    //delete
    deleteAble(data) {
      this.deleteData = data;
      this.deleteDialog = true;
    },
    async deleteItem(id) {
      await this.name.deleteItem(id);
      this.deleteDialog = false;
      this.name.get({ semester_id: this.id });
    },
  },
  computed: {
    name() {
      return Educational;
    },
    items() {
      return this.name.tableData.data;
    },

    //loaders
    loader() {
      return this.name.getState.loading;
    },
    craeteLoader() {
      return this.name.postState.loading;
    },
    editLoader() {
      return this.name.editState.loading;
    },
    deleteLoader() {
      return this.name.deleteState.loading;
    },
  },
  created() {
    this.name.get({ semester_id: this.id });
  },
};
</script>
